export default {"src":"/_next/static/media/INFO_ICON.371789a4.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};